var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { CloseIcon, Link } from '@paypalcorp/pp-react';
import './style.css';
// import './countrySelector.css'; // Use this only for local dev.
/**
CSS stylesheet is loaded remotely and is minimmized for obvious reasons
The following is a list of what each abbreviated class name stands for
--------------------------------------------------------------------------------
ls: locale selector
ll: locale list
cs: country selector
csBtn: individual country selector flag as a button
pc: priority countries
wrp: wrapper
csm: country selector modal
up: transition upward
mc: modal content
 */
export default function ({ authEventHandler, countryCode, logger }) {
    const [countryData, setCountryData] = useState(null);
    const [showCountrySelector, setShowCountrySelector] = useState(false);
    const [slideUp, setSlideUp] = useState(false);
    const [transitionUp, setTransitionUp] = useState(false);
    const [cssLoaded, setCssLoaded] = useState(false);
    useEffect(() => {
        const fetchCountriesAndStyles = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const countryList = yield fetch('https://www.paypalobjects.com/iwc/countryList.json');
                if (countryList.ok) {
                    countryList.json().then((data) => {
                        /**
                        Country data is a JSON blob with country codes as keys
                        and an array for every key's value, for example:
                        {
                          US: [1, "United States", ["en_US", "fr_XC", "es_XC", "zh_XC"], ["English", "Français", "Español", "中文"]],
                        }
                        Here ^, US is the country code, 1 is the priority, "United States" is the name of the country
                        and the balance 2 arrays are locale and language names applicable for the country where
                        the first one is the default language for the country denoted by the key
                        */
                        setCountryData(data);
                    });
                }
                const cssFile = 'https://www.paypalobjects.com/iwc/countrySelector.css';
                const styles = yield fetch(cssFile);
                if (styles.ok) {
                    const link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = cssFile;
                    document.head.appendChild(link);
                    setCssLoaded(true);
                }
            }
            catch (err) {
                console.log(err);
            }
        });
        fetchCountriesAndStyles();
    }, []);
    useEffect(() => {
        if (slideUp) {
            setShowCountrySelector(true);
            setTimeout(() => {
                setTransitionUp(true);
            }, 1);
        }
        else {
            setTransitionUp(false);
            setTimeout(() => {
                setShowCountrySelector(false);
            }, 300);
        }
    }, [slideUp]);
    const getLocalesList = () => countryData[countryCode][2].map((lang, idx) => (React.createElement("li", { key: idx },
        React.createElement(Link, { href: "#" // enables selection with keyboard
            , size: "sm", style: { color: 'gray', fontSize: '11px', fontWeight: 'bold' }, lang: lang.split('_')[0], "data-locale": lang, key: lang, onClick: (e) => {
                e.preventDefault();
                logger.track('locale_changed'); // TODO send dynamic value for the changed locale once available
                authEventHandler({
                    event: 'changeLocale',
                    data: {
                        countryCode,
                        language: e.target.dataset.locale,
                    },
                });
            } }, countryData[countryCode][3][idx]))));
    const getModalCountry = (cc) => {
        return (React.createElement("li", { key: cc },
            React.createElement("a", { href: "#" // enables selection with keyboard
                , className: `iwc-csBtn ${cc}`, "data-country-code": cc, "data-locale": countryData[cc][2][0], style: { cursor: 'pointer', fontWeight: 'bold' }, onClick: (e) => {
                    e.preventDefault();
                    authEventHandler({
                        event: 'changeLocale',
                        data: {
                            countryCode: cc,
                            language: countryData[cc][2][0],
                        },
                    });
                    setSlideUp(false); // this will slide down the country selector and unmount it
                } }, countryData[cc][1])));
    };
    const getCountrySelectorModal = () => {
        const priorityCountries = [];
        const restOfTheWorld = [];
        window.scrollTo(0, 0);
        for (const [cc, values] of Object.entries(countryData)) {
            if (values[0] === 1) {
                priorityCountries.push(getModalCountry(cc));
            }
            else {
                restOfTheWorld.push(getModalCountry(cc));
            }
        }
        priorityCountries.sort((a, b) => {
            return a.key > b.key ? 1 : -1;
        });
        restOfTheWorld.sort((a, b) => {
            return a.key > b.key ? 1 : -1;
        });
        return (React.createElement("div", { className: `iwc-csm ${transitionUp ? 'iwc-up' : ''}`, dir: "ltr" },
            React.createElement("div", { className: "iwc-wrp" },
                React.createElement("header", null,
                    React.createElement(CloseIcon, { tabIndex: "0", style: { cursor: 'pointer', float: 'right', padding: '10px' }, onClick: () => {
                            setSlideUp(false);
                        } })),
                React.createElement("div", { className: "iwc-mc", style: { overflowY: 'scroll', height: '100vh' } },
                    React.createElement("div", { className: "iwc-cs" },
                        React.createElement("ul", { className: "iwc-pc" }, priorityCountries),
                        React.createElement("ul", null, restOfTheWorld))))));
    };
    if (!countryData || !cssLoaded)
        return '';
    return (React.createElement(React.Fragment, null,
        showCountrySelector && getCountrySelectorModal(),
        React.createElement("div", { className: "iwc-ls", style: { marginTop: '30px' } },
            React.createElement("div", { className: "iwc-cs" },
                React.createElement("button", { onClick: () => {
                        setSlideUp(true);
                    }, type: "button", className: `iwc-csBtn iwc-csBtnDd ${countryCode}`, id: "countrySelectorButton", "data-testid": "country-selector-button", "aria-label": "Country Selector" })),
            React.createElement("ul", { className: "iwc-ll" }, getLocalesList()))));
}
